import { base_url } from "../config/apiConfig";
import {removeSpace} from "../components/Helpers";

export const fetchRegions = (oracleEmployee) => {
    return fetch(
        `${base_url}/region?oracleEmployee=${oracleEmployee}`,
        {
            method: 'GET',
            headers: {'Content-Type': 'application/json'}
        }
    );
};

export const fetchEmailToken = (emailToken) => {
  return fetch(
      `${base_url}/email/verifyEmail?token=${emailToken}`,
      {
          method: 'GET',
          headers: {'Content-Type': 'application/json'}
      });
};

export const fetchAssociatedAccounts = (email) => {
    return fetch(
        `${base_url}/sendAssociatedAccountsByEmail?email=${email}`,
        {
            method: 'GET',
            headers: {'Content-Type': 'application/json'}
        });
};

export const fetchBanner = () => {
    return fetch(
        `${base_url}/banner`,
        {
            method: 'GET',
            headers: {'Content-Type': 'application/json'}
        });
};

export const fetchValidateAccount = (body) => {
    return fetch(
        `${base_url}/validateAccountName`,
        {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: body
        }
    );
};

export const fetchValidateAccountRecursively = (body) => {
    return fetch(
        `${base_url}/validateAccountName`,
        {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: body
        }
    );
};

export const fetchSecurityLink = (body) => {
    return fetch(
        `${base_url}/email/sendSecurityLink`,
        {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: body
        }
    );
};

export const fetchCaptchaToken = (body) => {
    return fetch (
        `${base_url}/verifyCaptchaToken`,
        {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: body
        }
    );
};

export const fetchPromotionGuests = (email, token) => {
    return fetch(
        `${base_url}/promotionGuests?email=${email}&captchaJwtToken=${token}`,
        {
            method: 'GET',
            headers: {'Content-Type': 'application/json'}
        }
    );
};

export const fetchValidateEmail = (body) => {
  return fetch(
      `${base_url}/validateEmail`,
      {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: body
      }
  );
};

export const fetchStateId = (country) => {
    return fetch(
        `${base_url}/states?countryId=${country}`,
        {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        }
    );
};

export const fetchPaymentsByEmail = (email, body) => {
    return fetch(
        `${base_url}/payments?email=${email}`,
        {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: body
        }
    );
};

export const fetchCreateAccount = (email, body) => {
    return fetch(
        `${base_url}/createAccount?email=${email}&language=en`,
        {
            method: 'POST',
            credentials: 'include',
            headers: {'Content-Type': 'application/json'},
            body: body
        }
    );
};
